import { emptyAdminApi as api } from "../emptyAdminApi";

export type RevenueTarget = {
  quarter: string;
  currency: "PHP";
  targetAmountCents: number;
  updatedAt: string;
  updatedBy: string;
};

export type RevenueTargetResponse = {
  target: RevenueTarget | null;
};

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRevenueTarget: build.query<RevenueTargetResponse, string>({
      query: (quarter) => ({
        url: "/sales/revenue-targets",
        method: "GET",
        params: { quarter },
      }),
      providesTags: (_result, _error, quarter) => [{ type: "RevenueTarget", id: quarter }],
    }),
    updateRevenueTarget: build.mutation<RevenueTargetResponse, {
      quarter: string;
      targetAmountCents: number;
    }>({
      query: (body) => ({
        url: "/sales/revenue-targets",
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, body) => [{ type: "RevenueTarget", id: body.quarter }],
    }),
  }),
});

export const {
  useGetRevenueTargetQuery,
  useUpdateRevenueTargetMutation,
} = injectedApi;
